import { useEffect, useState } from "react";
import MultiTable from "../../../../Common/MUITable";
import { ExportInspectionReport } from "../ExportInspectionReport";
import InspectionReportFilter from "../InspectionReportFilter";
import { getInspectionReportWards } from "../inspectionReportApi";
import { useConditionsOfDhalaoStore } from "./store/useConditionsOfDhalaoStore";

const columns = [
  {
    label: "Ward",
    field: "wardId",
    width: "120px",
    render: (row) => row.circleName ?? row.wardName ?? "N/A",
  },
  { label: "Location ID", field: "locationId" ,width: "150px" },
  { label: "Asset Code", field: "assetCode", width: "150px" },
  { label: "Asset Type", field: "assetType", width: "220px" },
  { label: "Date of inspection", field: "dateOfInspection" },
  { label: "Physical Condition", field: "physicalCondition" ,width: "200px"},
  { label: "Signboard", field: "signboard",width: "200px" },
  { label: "Paint", field: "paint",width: "200px" },
  { label: "Flooring", field: "flooring",width: "200px"  },
  { label: "Bins", field: "bins",width: "200px"  },
  {
    label: "Littering outside the Dhalao & Any Other",
    field: "litteringOutsideDhalaoAndAnyOther",
  },
  { label: "Washing date(s)", field: "washingDates" },
];

const ConditionsOfDhalaoReport = () => {
  const [wardOptions, setWardOptions] = useState([]);
  const {
    rows,
    filters,
    isLoading,
    page,
    pageSize,
    totalRecords,
    fetchReport,
    resetFilters,
    changePage,
    changePageSize,
    fetchExportData,
  } = useConditionsOfDhalaoStore();

  useEffect(() => {
    const loadMasterData = async () => {
      try {
        const wards = await getInspectionReportWards();
        const activeWards = wards.filter((ward) => ward.isActive !== false);
        setWardOptions(activeWards);
      } catch (error) {
        console.error("Failed to load inspection report wards:", error);
        setWardOptions([]);
      }
    };

    loadMasterData();
    fetchReport(filters);
    // Initial load only; subsequent searches/resets are user-driven.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="content text-start">
      <div className="page-content">
        <div className="d-flex justify-content-between align-items-start flex-wrap gap-3 mt-3">
          <div>
            <h5 className="mb-1 fw-semibold">Conditions Of Dhalao</h5>
            <p className="text-muted mb-0">
             View and manage conditions of Dhalao inspections.
            </p>
          </div>
          <div className="d-flex align-items-center flex-wrap">
            <ExportInspectionReport
              reportData={rows}
              loadExportData={fetchExportData}
              reportTitle="Conditions Of Dhalao"
              columns={columns}
              fileName="ConditionsOfDhalao"
            />
          </div>
        </div>

        <div className="card shadow mt-3">
          <div className="card-body">
            <InspectionReportFilter
              initialValues={filters}
              wardOptions={wardOptions}
              onSearch={fetchReport}
              onReset={resetFilters}
            />

            <MultiTable
              loading={isLoading}
              needSRNumber
              rows={rows}
              columns={columns}
              serverPagination
              totalCount={totalRecords}
              page={page}
              rowsPerPage={pageSize}
              onPageChange={(_event, newPage) => changePage(newPage)}
              onRowsPerPageChange={(event) =>
                changePageSize(parseInt(event.target.value, 10))
              }
              rowsPerPageOptions={[10, 50, 100, 1000, 10000, 50000]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConditionsOfDhalaoReport;
